export const PREVIEW_CREATION_SIZES_FEED_CAMPAIGN = [
  '750x200',
  '970x300',
  '300x600',
]
